/**
 *
 * Pficon
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import 'fonts/icomoon/style.css';

const buildMultiLayerPaths = (type, props, paths) => {
  const items = [];
  const { size, style, disabled = false, ...restProps } = props;
  for (let i = 1; i <= paths; i += 1) {
    items.push(<span key={i} className={`path path${i}`} />);
  }
  return (
    <span
      {...restProps}
      className={classNames(`icon icon-${type} ${props.className || ''}`, {
        'icon-disabled': disabled,
      })}
      style={getStyle(size, style)}
    >
      {items}
    </span>
  );
};

const getStyle = (size, existingStyle) => {
  const style = size
    ? {
        ...existingStyle,
        fontSize: typeof size === 'string' ? size : `${size}px`,
      }
    : existingStyle;
  return style;
};

const Pficon = (props) => {
  const type = props.type.toLowerCase().replace(/ /g, '');
  const { size, style = {}, disabled, ...restProps } = props;
  switch (type) {
    case 'bipolar-matrix': {
      return buildMultiLayerPaths(
        type,
        { className: `${props.className} color-grey-10` },
        5,
      );
    }
    case 'van-westendorp-group':
      return buildMultiLayerPaths(
        type,
        { ...props, className: `${props.className} color-grey-10` },
        6,
      );
    case 'van-westendorp-question':
      return buildMultiLayerPaths(
        type,
        { ...props, className: `${props.className} color-grey-10` },
        3,
      );
    case 'ab-group':
    case 'conjoint':
    case 'drilldown-upload':
    case 'headphones':
      return buildMultiLayerPaths(type, props, 2);
    case 'drilldown-batch':
    case 'open-ended-numeric-new': {
      return buildMultiLayerPaths(type, props, 3);
    }
    case 'matrix-noe-new':
      return buildMultiLayerPaths(type, props, 4);
    case 'maxdiff-group':
    case 'open-ended-new': {
      return buildMultiLayerPaths(type, props, 5);
    }
    case 'americanexpress':
    case 'conjoint-preview':
    case 'crown':
    case 'jcb': {
      return buildMultiLayerPaths(type, props, 4);
    }
    case 'visa':
    case 'matrix-oe': {
      return buildMultiLayerPaths(type, props, 6);
    }
    case 'discover': {
      return buildMultiLayerPaths(type, props, 10);
    }
    case 'unionpay': {
      return buildMultiLayerPaths(type, props, 14);
    }
    case 'maestro':
    case 'unknown': {
      return buildMultiLayerPaths(type, props, 16);
    }
    case 'cirrus': {
      return buildMultiLayerPaths(type, props, 17);
    }
    case 'mastercard': {
      return buildMultiLayerPaths(type, props, 21);
    }
    case 'dinersclub': {
      return buildMultiLayerPaths(type, props, 40);
    }
    case 'pro-user-badge': {
      return buildMultiLayerPaths(type, props, 3);
    }
    case 'elite-user-badge': {
      return buildMultiLayerPaths(type, props, 4);
    }
    case 'required-star-checked': {
      return buildMultiLayerPaths(type, props, 2);
    }
    case 'required-star-frame': {
      return buildMultiLayerPaths(type, props, 2);
    }
    case 'matrix-noe': {
      return buildMultiLayerPaths(type, props, 3);
    }
    case 'earnings': {
      return buildMultiLayerPaths(type, props, 53);
    }
    case 'services-stars': {
      return buildMultiLayerPaths(type, props, 4);
    }
    case 'generate-answers-color':
      return buildMultiLayerPaths(type, props, 4);
    case 'rephrase-color':
      return buildMultiLayerPaths(type, props, 5);
    case 'set-tone-color':
      return buildMultiLayerPaths(type, props, 3);
    case 'generate-media-color':
      return buildMultiLayerPaths(type, props, 3);
    case 'translate-color':
      return buildMultiLayerPaths(type, props, 3);
    case 'brandfeedback-color':
      return buildMultiLayerPaths(type, props, 4);
    case 'conjoint-color':
      return buildMultiLayerPaths(type, props, 5);
    case 'createsurvey-color':
      return buildMultiLayerPaths(type, props, 4);
    case 'customerfeedback-color':
      return buildMultiLayerPaths(type, props, 3);
    case 'maxdiff-color':
      return buildMultiLayerPaths(type, props, 3);
    case 'pricing-color':
      return buildMultiLayerPaths(type, props, 4);
    case 'productfeedback-color':
      return buildMultiLayerPaths(type, props, 3);
    case 'maxdiff-preview':
      return buildMultiLayerPaths(type, props, 2);
    case 'quota-rule-square':
      return buildMultiLayerPaths(type, props, 2);
    default:
      return (
        <span
          {...restProps}
          role="img"
          className={classNames(`icon icon-${type} ${props.className || ''}`, {
            'icon-disabled': disabled,
          })}
          style={getStyle(size, style)}
        />
      );
  }
};

Pficon.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

Pficon.defaultProps = {
  type: '',
};

export default Pficon;
